import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'store/RootState'
import { initialState } from './slice'

const selectMenuState = (state: RootState) => state.Menu || initialState

export const menuSelector = createSelector([selectMenuState], Menu => Menu)
